module.exports = __webpack_public_path__ + "static/media/cheif.dc2948fc.svg";